module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Interselect-fc525efc8a946bc15ca7078e076caa48.svg";